import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Copy, H5, Icon, IconWrapper } from '@honda-canada/design-system-react';
import themeStyles from './styles/StatusChange.styles';
const ModalTitleContainer = themeStyles.apply(Box, 'ModalTitleContainer');
const ModalMessage = themeStyles.apply(Copy, 'ModalMessage');
const CloseButton = themeStyles.apply('button', 'CloseButton');
const StatusChangeModalContent = ({ modalMessage, modelCloseHandler }) => {
    const { t } = useTranslation();
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalTitleContainer, null,
            React.createElement(H5, null, t('Shared.Common.statusChangeModalHeading')),
            React.createElement(CloseButton, { "aria-label": t('Shared.Common.closeAria'), "tab-index": "1", onClick: () => modelCloseHandler(), "data-testid": "cy-modal-close-button" },
                React.createElement(IconWrapper, { size: "iconWrapper.md" },
                    React.createElement(Icon, { name: "close", iconSize: "default" })))),
        React.createElement(ModalMessage, { size: "regular" }, modalMessage)));
};
export default StatusChangeModalContent;
